<!-- Spacer -->
<div
    class="ioteq-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
